export default __webpack_public_path__ + "static/media/amte.176d790b.png";